import { Injectable } from '@angular/core';
import { Account, validateToken } from './account.service';
import {
	CanActivate, Router,
	ActivatedRouteSnapshot,
	ActivatedRoute,
	RouterStateSnapshot,
	CanActivateChild
} from '@angular/router';
import { OAuthResponse } from './oauth_response';
import { Config } from './config';
import { OneRosterService } from './oneroster.service';
import { OAuthTokenRequest } from './oauth-token-request';
import { Observable } from 'rxjs';
import { TokenHelper } from './token_helper';


@Injectable()
export class Auth implements CanActivate {
	public ar: OAuthResponse;
	constructor(private account: Account, private config: Config, private svc: OneRosterService) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		let path: string = window.location.href;
		if (path.indexOf("#access_token=") === -1) {
			if (validateToken()) {

				// handle cases where user changes the acctnumber in url but existing userrole is different
				// solution is to re-load user roles
				let acctNumber = route.params['acctNumber'];
				if (acctNumber) {
					return this.svc.validateAcctNumber(acctNumber)
						.mergeMap(valid => {
							if (!valid) {
								console.log(`re-load user roles for acctNumber ${acctNumber}`);
								return this.svc.loadUserByAcctNumber(acctNumber)
									.catch(err => {
										console.log(err);
										return Observable.of(null);
									})
									.map(() => {
										return true;
									});
							}
							return Observable.of(true);
						});
				}
				return Observable.of(true);
			}
			console.log('token invalid, redirecting to login page.');

			let redirectLogin = () => {

				if (path.indexOf("#") != -1) {
					let baseUrl = path.substring(0, path.indexOf("#"));
					let gotopage = path.substr(path.indexOf("#") + 1);
					// there are cases where gotopage query param is set on url
					// in this case we need to take that value else take the default url
					if (path.indexOf('gotopage=') != -1) {
						let fg = this.parseQueryString(path.substr(path.indexOf('?') + 1));
						gotopage = fg['gotopage'];
					}
					gotopage = encodeURIComponent(gotopage);
					window.location.href = this.config.loginUrl() + `?navigateUri=${gotopage}`;
				} else {
					window.location.href = this.config.loginUrl();
				}
			}

			let t = this.account.getToken();
			// if refresh token is empty, ask user to re-login
			// refresh_token will be provided only when user has checked to stay signin

			if (!t || !t.refreshToken) {
				console.log('no refresh token');
				redirectLogin();
				return Observable.of(false);
			}

			// try to get new token based on refresh token
			//
			let oauthreq = new OAuthTokenRequest();
			oauthreq.refreshToken = t.refreshToken;
			return this.svc.oauthTokenApi(oauthreq)
				.map(data => {

					let th = new TokenHelper();
					t.accessToken = data.accessToken;
					t.refreshToken = data.refreshToken;
					t.tokenType = data.tokenType;
					t.expiresIn = data.expiresIn;
					t.expiresAt = th.getExpiresAt(data.expiresIn);

					this.account.setToken(t);
					return true;
				})
				.catch(err => {
					console.log(err)
					redirectLogin();
					return Observable.of(false)
				});

		} else {
			let fg = this.getFragment();
			this.setToken(fg);
			// gotopage param is to navigate the user to specific page after it is login
			let gotopage = fg['gotopage'];
			if (gotopage) {
				//gotopage = decodeURIComponent(gotopage);
				this.config.saveGoToPage(gotopage);
			}
			window.location.href = '/#/login';
			//this will stop angular accessing wrong page like #/access_token and insted of that it will change the url to /#/login
			return Observable.of(false);
		}
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.canActivate(route, state);
	}

	setToken(queryParam: any) {
		this.ar = new OAuthResponse();
		this.ar.accessToken = queryParam['access_token'];
		this.ar.tokenType = queryParam['token_type'];
		this.ar.state = queryParam['state'];
		this.ar.scope = queryParam['scope'];
		this.ar.expiresIn = parseInt(queryParam['expires_in']);
		if (queryParam['refresh_token']) {
			this.ar.refreshToken = queryParam['refresh_token'];
		}
		this.account.oauthLogin(this.ar);
	}

	getFragment() {
		if (window.location.hash.indexOf("#") === 0) {
			return this.parseQueryString(window.location.hash.substr(1));
		} else {
			return {};
		}
	};

	parseQueryString(queryString) {
		var data = {}, pairs, pair, separatorIndex, escapedKey, escapedValue, key, value;

		if (queryString === null) {
			return data;
		}

		pairs = queryString.split("&");

		for (var i = 0; i < pairs.length; i++) {
			pair = pairs[i];
			separatorIndex = pair.indexOf("=");

			if (separatorIndex === -1) {
				escapedKey = pair;
				escapedValue = null;
			} else {
				escapedKey = pair.substr(0, separatorIndex);
				escapedValue = pair.substr(separatorIndex + 1);
			}

			key = decodeURIComponent(escapedKey);
			value = decodeURIComponent(escapedValue);

			if (key.substr(0, 1) === '/')
				key = key.substr(1);

			data[key] = value;
		}

		return data;
	};
}
